import "vant/es/list/style";
import _List from "vant/es/list";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue";
import { watch } from 'vue';
import ChannelCell from '@/components/channel/channel-cell.vue';
import composition from '@/composition';
export default {
  props: {
    order: String,
    cid: Number,
    tagId: String,
    type: String
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      request,
      computed,
      store
    } = composition();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const error = ref(false); // 错误状态

    let page = 1;

    const onLoad = () => {
      let order = props.order;

      if (props.order == undefined) {
        // 没传参
        order = listOrder.value;
      }

      console.log('pro', props.cid);
      request.getPostList({
        categoryId: props.cid,
        type: props.type ? props.type : 'MOMENT',
        tagId: props.tagId,
        order,
        page
      }).then(res => {
        loading.value = false;

        if (res.data.length == 0) {
          finished.value = true;
        }

        page++;
        list.value = list.value.concat(res.data);
      });
    };

    const listOrder = computed(() => {
      return store.state.listOrder;
    });
    watch(listOrder, () => {
      // 初始化
      finished.value = false;
      loading.value = true;
      error.value = false;
      page = 1;
      list.value = [];
      onLoad();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(_List), {
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
        error: error.value,
        "onUpdate:error": _cache[1] || (_cache[1] = $event => error.value = $event),
        finished: finished.value,
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return _openBlock(), _createBlock(ChannelCell, {
            key: item.id + '-' + index,
            item: item
          }, null, 8, ["item"]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "error", "finished"]);
    };
  }

};